// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // For Prod Deployement
  apiUrl:"https://vehiclemaintenance.avis.com.au/api/dev/",
  usertokenUrl:"https://vehiclemaintenance.avis.com.au",
  
  // For UAT Deployement
  // apiUrl:"http://172.16.251.57:5588/api/dev/",
  // usertokenUrl:"http://172.16.251.57:5588",

  timeOut:3600000
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
